import * as React from 'react'

import { cn } from '@/utilities/cn'

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex field-sizing-content min-h-24 w-full rounded-2xl border-2 border-ink/15 bg-foam px-4 py-3 text-base text-ink transition-colors outline-none',
        'placeholder:text-ink/40 disabled:cursor-not-allowed disabled:opacity-50',
        'focus:border-ink focus-visible:border-ink aria-invalid:border-punch',
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
